export { default } from './SkeletonLightMonthlyHistogramMobile';
